<template>
  <div>
    <div id="bg" :style="logoutPopupStyle" v-on:click="clearpopup"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <div class="logoutPop" :style="logoutPopupStyle">
        <p>
          <span>로그아웃 시,</span>
          <br />동일 계정(닉네임)으로 재참여할 수 없습니다.
          정말 로그아웃 하시겠습니까?
        </p>
        <div class="btn">
          <a href="#" class="check" style="margin-right:3px;" @click.prevent="confirm">확인</a>
          <a href="#" @click="cancel">취소</a>
        </div>
      </div>

      <header id="headerMain">
        <div class="userinfo" @click="openLogoutButton">
          <h2>
            {{default_info}}
            <img src="@/assets/img/icon_arrow.png" />
          </h2>
          <div class="logoutBtn" :style="logoutStyle">
            <a href="#" @click.prevent="logout">
              로그아웃
              <img src="@/assets/img/logout.png" alt="로그아웃" />
            </a>
          </div>
        </div>
        <div class="menu">
          <a href class="home" @click.prevent="goHome">
            <img src="@/assets/img/home.png" alt="홈" />
          </a>
          <a href="#" class="ttable" v-if="hasTimeTable" title="메뉴" @click.prevent="timetable">
            <img src="@/assets/img/ttable.png" alt="메뉴" />
          </a>

          <a href="#" title="메뉴">
            <img src="@/assets/img/menu.png" alt="메뉴" @click="toggleGnb" />
          </a>
        </div>
      </header>
      <!-- //header -->
      <Gnb v-if="showGnb" />
      <div id="container" v-on:click="clearpopup">
        <section id="contents">
          <div class="main">
            <div class="main_basic">
              <div class="img">
                <img :src="bgsrc" alt="background" style="height:401px;object-fit:cover;" />
              </div>
              <div class="basic text">
                <div class="logo">
                  <img src="@/assets/img/main_logo.png" alt="weliveOn" />
                </div>
                <h3 v-html="welcome_msg"></h3>
                <div class="bannerSlider">
                  <div class="swiper-container">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide">
                        <img src="@/assets/img/basic_icon.png" alt class="default" />
                      </div>

                      <div class="swiper-slide">
                        <img src="@/assets/img/test_ban.png" alt />
                      </div>
                    </div>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
                <!-- bannerSlider -->
              </div>
              <!-- basic -->
            </div>
            <div class="mainClass">
              <h5 class="todayClass" @click="sendtest">Today Class</h5>
              <h3 class="classTitle">{{this.attInfo.title}}</h3>
              <div class="img">
                <img :src="logo_src" alt />
              </div>
            </div>
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
import Gnb from "@/components/Gnb";
export default {
  mounted() {
    let that = this;
  },
  created() {
    this.$store.state.bannersrc = null;
    let clsid = localStorage.getItem("clsid");
    this.$store.dispatch("setClassInfo", clsid);
  },

  components: { Gnb },
  data: function() {
    return {
      showMenu: false,
      showPopup: false,
      swiper: null
    };
  },
  computed: {
    // sockettime() {
    //   return this.$store.state.sockettime;
    // },
    hasTimeTable() {
      return this.$store.state.hasTimeTable;
    },
    bgsrc() {
      let banner = this.$store.getters.getClsMeta.bg;
      if (banner != null) {
        banner = JSON.parse(banner).url;
      } else {
        banner = require("@/assets/img/index_bg2.png");
      }

      return banner;
    },
    bannersrc() {
      let b = this.$store.state.bannersrc;

      return b;
    },
    bannerlink() {
      let b = this.$store.getters.getClsMeta.banner;
      if (b != undefined) {
        b = JSON.parse(b).link;
      }
      return b;
    },

    showGnb: function() {
      return this.$store.getters.getShowGnb;
    },
    default_info: function() {
      //hack: i have no idea thats not work with getters code
      return localStorage.getItem("default_info");
    },
    logoutStyle: function() {
      if (this.showMenu) {
        return "display:block";
      } else {
        return "display:none";
      }
    },
    logoutPopupStyle: function() {
      if (this.showPopup) {
        return "display:block";
      } else {
        return "display:none";
      }
    },
    attInfo() {
      return this.$store.getters.getClsMeta;
    },
    welcome_msg() {
      let welcome_msg = this.attInfo.welcome;
      if (welcome_msg != null) {
        return welcome_msg;
      } else {
        return "실시간 커뮤니케이션 플랫폼<br />위라이브온에 오신 것을 환영합니다!";
      }
    },
    logo_src() {
      /// @/assets/img/mega_logo.png
      let logo_src = this.attInfo.logo;
      if (logo_src != null) {
        return JSON.parse(logo_src).url;
      } else {
        return require("@/assets/img/mega_logo.png");
      }
    }
  },
  watch: {
    bannersrc(val) {
      let that = this;
      if (val != null) {
        this.$nextTick(function() {
          that.swiper = new Swiper(".swiper-container", {
            onlyExternal: true,
            noSwiping: true,
            preventClicksPropagation: false,
            preventClicks: false,
            allowTouchMove: false,
            autoplay: {
              delay: 2500,
              disableOnInteraction: true
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true
            }
          });

          let mk = `<div class="swiper-slide"><img class="normal" src=${val} /></div>`;
          this.swiper.addSlide(1, [mk]);
          this.swiper.on("touchEnd", function(k) {
            if (that.swiper.activeIndex === 1) {
              that.outerlink();
            }
          });
        });
      }
    }
  },
  methods: {
    sendtest() {
      let wrapper = {};
      wrapper.wayto = "ACTION_TEST_TEST1";
      wrapper.from = "";
      wrapper.to = "";
      wrapper.payload = "";
      this.$store.dispatch("pushWSMessage", wrapper);
    },
    timetable() {
      this.$router.push("/timetable");
    },
    openLogoutButton: function() {
      // this.showMenu = true;
      this.showMenu = !this.showMenu;
    },
    logout: function() {
      this.showMenu = false;
      this.showPopup = true;
    },
    confirm: function() {
      //DONE: goto  login screen
      let clsid = localStorage.getItem("clsid");
      localStorage.removeItem("default_info_" + clsid);
      localStorage.removeItem("default_info");
      // localStorage.removeItem("clsid");
      localStorage.removeItem("bannersrc");

      // localStorage.clear();
      //todo: socket logout
      this.$store.dispatch("logoutSocket");
      // this.$router.replace("/login/" + clsid);
    },
    cancel: function() {
      this.showMenu = false;
      this.showPopup = false;
    },
    clearpopup: function() {
      this.showMenu = false;
      this.showPopup = false;
      this.$store.dispatch("offGnb");
    },
    toggleGnb: function() {
      this.$store.dispatch("toggleGnb");
    },
    goHome() {},
    outerlink() {
      window.open(this.bannerlink);
    }
  }
};
</script>


<style lang="scss">
#container {
  min-height: 100vh;
}
.main {
  text-align: center;
  padding-top: 55px;
  padding-bottom: 20px;
  min-height: 100vh;
  position: relative;
  background: #d7d7d7;
}
/* .main:before{
        content:"";
        display: block;
        height: 44vh;
        width: 100%;
        background: #2f2f30;
        left:0;
        bottom:0;
        position: absolute;
    
    } */

/* 2020-04-22 css 수정 시작 */
.main_basic {
  position: relative;
}
.main_basic .logo {
  margin-bottom: 15px;
}
.main_basic .logo img {
  width: 125px;
}
.main_basic h3 {
  font-size: 16px;
  color: #ffffff;
}
.main_basic .icon {
  margin: 26px auto 10px;
}
.main_basic .icon img {
  width: 107px;
  margin-left: -10px;
}
.main_basic p {
  font-size: 14px;
  color: #ffffff;
}
.main_basic .img {
  overflow: hidden;
}
.main_basic .img img {
  width: 100%;
}
.main_basic .text {
  position: absolute;
  left: 50%;
  top: 48%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.main_basic .text {
}
.bannerSlider {
  width: 100%;
  margin: 40px auto 0;
}
.bannerSlider .swiper-slide {
  padding: 0 3%;
}
.bannerSlider .swiper-slide img {
  width: 100%;
}
.bannerSlider .swiper-slide img.default {
  width: 100px;
}

.bannerSlider .swiper-slide img.normal {
  // width: 100px;
  max-height: 150px;
  width: auto;
}

.bannerSlider .swiper-pagination {
  position: static;
  margin-top: 5px;
}
.bannerSlider .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 100%;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0.3;
  margin: 0 3px;
}
.bannerSlider .swiper-pagination-bullet-active {
  opacity: 1;
  background: rgba(255, 255, 255, 1);
}
/* 2020-04-22 css 수정 끝 */

.mainSlider {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
}
.mainSlider ul {
  text-align: left;
  position: relative;
  font-size: 0;
}
.mainSlider ul li {
  display: inline-block;
  vertical-align: top;
  text-align: center;
  position: relative;
}
.mainSlider ul li .logo {
  margin-bottom: 15px;
}
.mainSlider ul li .logo img {
  width: 125px;
}
.mainSlider ul li h3 {
  font-size: 16px;
  color: #ffffff;
}
.mainSlider ul li .icon {
  margin: 26px auto 10px;
}
.mainSlider ul li .icon img {
  width: 107px;
  margin-left: -10px;
}
.mainSlider ul li p {
  font-size: 14px;
  color: #ffffff;
}
.mainSlider ul li .img {
  overflow: hidden;
}
.mainSlider ul li .img img {
  width: 100%;
}
.mainSlider ul li .text {
  position: absolute;
  left: 50%;
  top: 38%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.mainSlider .paging {
  margin-top: 20px;
  position: absolute;
  bottom: 55px;
  left: 0;
  width: 100%;
}
.mainSlider .paging ul {
  text-align: center;
}
.mainSlider .paging ul li {
  display: inline-block;
  vertical-align: top;
  margin: 0 3px;
  padding-top: 30px;
}
.mainSlider .paging ul li a {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: block;
}
.mainSlider .paging ul li.active a {
  background: rgba(255, 255, 255, 1);
}

.mainClass {
  position: relative;
  z-index: 2;
  border-radius: 10px;
  background: #ffffff;
  width: 90%;
  margin: -40px auto;
  padding-bottom: 30px;
  box-shadow: 5px 5px 10px 2px rgba(0, 0, 0, 0.3);
}
.mainClass h5.todayClass {
  width: 125px;
  margin: 0 auto;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  background: #49c5c5;
  border-radius: 0 0 10px 10px;
}
.mainClass h3.classTitle {
  color: #2c3a38;
  font-size: 23px;
  text-align: center;
  padding: 0 10%;
  font-weight: 600;
  line-height: 1.2em;
  margin-top: 20px;
}
.mainClass .img {
  width: 90%;
  margin: 10px auto 0;
  // height: 50px;
  line-height: 50px;
  border: 1px solid #f4f1f1;
  border-radius: 10px;
}
.mainClass .img img {
  width: 33%;
}
.mainClass .icon {
  width: 95px;
  height: 95px;
  border-radius: 100%;
  line-height: 95px;
  background: #f9f9f9;
  text-align: center;
  margin: 25px auto;
}
.mainClass .icon img {
  width: 50px;
}
.mainClass p {
  color: #c0c0c0;
  font-size: 14px;
  text-align: center;
}

.logoutBtn {
  background: #fff;
  text-align: center;
  width: 111px;
  border-radius: 8px;
  box-shadow: 1px 1px 6px 2px rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 20px;
  top: 85%;
}
.logoutBtn a {
  color: #666666;
  font-size: 16px;
  display: block;
  height: 40px;
  line-height: 40px;
}
.logoutBtn a img {
  width: 17.5px;
  margin: -2px 0 0 3px;
}

.logoutPop {
  position: fixed;
  left: 50%;
  top: 80px;
  z-index: 100;
  background: #ffffff;
  transform: translateX(-50%);
  width: 90%;
  border-radius: 10px;
  padding: 20px;
}
.logoutPop p {
  color: #666666;
  font-size: 14px;
  line-height: 1.6em;
  text-align: center;
}
.logoutPop p span {
  color: #000000;
}
.logoutPop .btn {
  text-align: center;
  margin-top: 10px;
}
.logoutPop .btn a {
  width: 85px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  color: #ffffff;
  background: #9f9f9f;
  border-radius: 5px;
  display: inline-block;
  vertical-align: top;
  font-size: 13px;
}
.logoutPop .btn a.check {
  background: #309f93;
}
</style>